import React from 'react';
import { CheckoutConfig } from '../../../types';

interface CroTabProps {
  config: CheckoutConfig;
  onUpdate: (partial: Partial<CheckoutConfig>) => void;
}

export const CheckoutStudioCroTab: React.FC<CroTabProps> = ({ config, onUpdate }) => {
  return (
    <div className="space-y-4 text-left">
      {/* FOMO Live Alert */}
      <div className="p-3.5 bg-slate-50 dark:bg-slate-900/60 rounded-xl border border-slate-200/80 dark:border-slate-800 space-y-3">
        <label className="flex items-center justify-between p-2.5 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 cursor-pointer">
          <div>
            <p className="text-xs font-bold text-slate-900 dark:text-white">Live Activity FOMO Urgency Alert</p>
            <p className="text-[11px] text-slate-500">Pulsing live badge prompting faster buyer action.</p>
          </div>
          <input
            type="checkbox"
            checked={Boolean(config.showFomo)}
            onChange={(e) => onUpdate({ showFomo: e.target.checked })}
            className="rounded text-indigo-600 focus:ring-indigo-500 w-4 h-4"
          />
        </label>

        {config.showFomo && (
          <div>
            <label className="text-[10px] font-bold text-slate-500 uppercase">Urgency Message</label>
            <input
              type="text"
              value={config.fomoMessage || ''}
              onChange={(e) => onUpdate({ fomoMessage: e.target.value })}
              placeholder="e.g. 14 teams joined this plan today"
              className="w-full text-xs px-2.5 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg outline-none mt-1"
            />
          </div>
        )}
      </div>

      {/* Promo Coupons */}
      <div className="p-3.5 bg-slate-50 dark:bg-slate-900/60 rounded-xl border border-slate-200/80 dark:border-slate-800 space-y-3">
        <label className="flex items-center justify-between p-2.5 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 cursor-pointer">
          <div>
            <p className="text-xs font-bold text-slate-900 dark:text-white">Allow Discount Coupons</p>
            <p className="text-[11px] text-slate-500">Enables coupon input box on checkout form.</p>
          </div>
          <input
            type="checkbox"
            checked={Boolean(config.allowCoupons)}
            onChange={(e) => onUpdate({ allowCoupons: e.target.checked })}
            className="rounded text-indigo-600 focus:ring-indigo-500 w-4 h-4"
          />
        </label>

        {config.allowCoupons && (
          <div className="grid grid-cols-2 gap-3 pt-1">
            <div>
              <label className="text-[10px] font-bold text-slate-500 uppercase">Input Placeholder</label>
              <input
                type="text"
                value={config.couponPlaceholder || ''}
                onChange={(e) => onUpdate({ couponPlaceholder: e.target.value })}
                placeholder="e.g. ENTER PROMO CODE"
                className="w-full text-xs px-2.5 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg outline-none mt-1 uppercase"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-slate-500 uppercase">Default Discount (%)</label>
              <input
                type="number"
                value={config.couponDiscountPercentage || 15}
                onChange={(e) => onUpdate({ couponDiscountPercentage: Number(e.target.value) })}
                className="w-full text-xs font-bold px-2.5 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg outline-none mt-1"
              />
            </div>
          </div>
        )}
      </div>

      {/* Social Proof */}
      <div className="p-3.5 bg-slate-50 dark:bg-slate-900/60 rounded-xl border border-slate-200/80 dark:border-slate-800 space-y-3">
        <label className="flex items-center justify-between p-2.5 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 cursor-pointer">
          <div>
            <p className="text-xs font-bold text-slate-900 dark:text-white">Social Proof Banner</p>
            <p className="text-[11px] text-slate-500">Highlights user count or trust statistics.</p>
          </div>
          <input
            type="checkbox"
            checked={Boolean(config.showSocialProof)}
            onChange={(e) => onUpdate({ showSocialProof: e.target.checked })}
            className="rounded text-indigo-600 focus:ring-indigo-500 w-4 h-4"
          />
        </label>

        {config.showSocialProof && (
          <div>
            <label className="text-[10px] font-bold text-slate-500 uppercase">Social Proof Text</label>
            <input
              type="text"
              value={config.socialProofText || ''}
              onChange={(e) => onUpdate({ socialProofText: e.target.value })}
              placeholder="e.g. Trusted by 10,000+ businesses worldwide"
              className="w-full text-xs px-2.5 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg outline-none mt-1"
            />
          </div>
        )}
      </div>
    </div>
  );
};
